<div class="notification notification-{{ severity | lowercase }}">
    {{ code | notificationText }}

    <button *ngIf="canClose" i18n class="button-game" (click)="closeClicked.emit()">Clear</button>
</div>
